<template>
    <div class="page-header align-items-start background-login">
        <div id="carouselExampleAutoplaying" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
            <div
            v-for="(image, index) in images"
            :key="index"
            :class="['carousel-item', { active: index === 0 }]"
            :data-bs-interval="4000"
            >
            <img :src="image" class="d-block w-100" alt="Background animado">
            </div>
        </div>
        </div>
    </div>
    <!-- <div class="bg-gradient-blue"></div> -->
</template>

<script>
export default {
    name: "BackgroundCarrusel",
    data() {
        return {
            images: []
        };
    },
    mounted() {
        this.setClientImages();
    },
    methods: {
        setClientImages() {
            const hostname = window.location.hostname.toLowerCase();

            // Mapeo por nombre de cliente
            const imageSets = {
                salfa: [
                    require("@/assets/img/backgrounds/salfa/01_img_login.jpg"),
                    require("@/assets/img/backgrounds/salfa/02_img_login.jpg"),
                    require("@/assets/img/backgrounds/salfa/03_img_login.jpg"),
                    require("@/assets/img/backgrounds/salfa/04_img_login.jpg")
                ],
                econorent: [
                    require("@/assets/img/backgrounds/econorent/01_img_login.jpg"),
                    require("@/assets/img/backgrounds/econorent/02_img_login.jpg"),
                    require("@/assets/img/backgrounds/econorent/03_img_login.jpg"),
                    require("@/assets/img/backgrounds/econorent/03_img_login.jpg")
                ],
                mitta: [
                    require("@/assets/img/backgrounds/mitta/01_img_login.jpg"),
                    require("@/assets/img/backgrounds/mitta/02_img_login.jpg"),
                    require("@/assets/img/backgrounds/mitta/03_img_login.jpg"),
                    require("@/assets/img/backgrounds/mitta/03_img_login.jpg")
                ]
            };

            // Buscar si el hostname contiene el nombre de alguno de los clientes
            const clientKey = Object.keys(imageSets).find(client =>
                hostname.includes(client)
            );

            // Si lo encuentra, asigna ese set; si no, usa imágenes por defecto
            this.images = imageSets[clientKey] || [
                require("@/assets/img/backgrounds/migps/01_img_login.jpg"),
                require("@/assets/img/backgrounds/migps/02_img_login.jpg"),
                require("@/assets/img/backgrounds/migps/01_img_login.jpg"),
                require("@/assets/img/backgrounds/migps/02_img_login.jpg")
            ];
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => vm.setClientImages());
    }
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/responsive" as r;

.background-login {
    opacity: 0.8;
    height: 100vh;
    width: 65vw;
    position: fixed;
    right: 35vw;
}

.carousel-item {
    height: 100vh;
    overflow: hidden;
}

.carousel-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
}

/* Tablet: el carrusel ocupa toda la pantalla como fondo */
@include r.tablet {
    .background-login {
        width: 100vw;
        right: 0;
    }
}

/* Teléfono: sin carrusel, solo el formulario */
@include r.phone {
    .background-login {
        display: none;
    }
}
</style>
